module.exports = __webpack_public_path__ + "img/kendaraan.c4d96899.webp";